import { useState } from "react";
import { FiChevronsDown } from "react-icons/fi";

import PropTypes from "prop-types";

/**
 * Contexts
 */
/**
 * Components
 */
import { scrollToBottomHeader } from "common/action-function/scrollToBottomHeader";
import { AutoConvertPriceWithUnit } from "common/priceConvert";

import Img from "components/atoms/Img";
import FormDownloadModal from "components/templates/common/post/FormDownloadModal";

import {
  ContentList,
  PackageContent,
  RenewalItem,
  SaleItem,
} from "./CardDesktop";

import styles from "./Index.module.scss";
/** ========== */

const CardMobile = ({ data, dataPackage, indexEntity, linkRegister }) => {
  const {
    content,
    notes,
    banner,
    bannerLink,
    dataForm,
    bestSeller,
    name,
    sale_off,
    renewal_fee,
    price_unit,
    price,
    renewal_sub,
    collapse_content,
  } = data || [];
  const [showFormDownload, setShowFormDownload] = useState(false);
  const [seeMore, setSeeMore] = useState([]);

  const showEbookBookModal = () => {
    setShowFormDownload(true);
  };

  return (
    <div
      style={{ maxWidth: "350px" }}
      className={` ${
        bestSeller ? "mt-16" : "mt-6"
      } relative m-auto flex h-full flex-col justify-between rounded-3xl bg-white`}
    >
      {bestSeller && (
        <div className="absolute -top-10 left-0 z-0 h-20 w-full rounded-t-[24px] bg-bbc-yellow-500 pt-1 text-center text-2xl font-semibold capitalize text-bbc-white">
          Best Seller
        </div>
      )}
      <div
        style={{ zIndex: "2", backgroundColor: "white", borderRadius: "24px" }}
      >
        <div
          style={{ borderBottomWidth: "1.5px" }}
          className={
            " border-b-bbc-neutral-500 px-8 pt-6  pb-7 text-center text-bbc-brand-700"
          }
        >
          <p
            style={{
              fontSize: "32px",
              lineHeight: "42px",
              letterSpacing: "0.25px",
            }}
            className="mb-8 font-semibold uppercase"
          >
            {name}
          </p>
          <p
            style={{
              fontSize: "50px",
              lineHeight: "54px",
              letterSpacing: "0.25px",
            }}
            className="mb-4 font-semibold"
          >
            <span>{AutoConvertPriceWithUnit(price, price_unit)}</span>
          </p>
          {sale_off && (
            <SaleItem
              price_unit={price_unit}
              sale_off={sale_off}
              priceClass="text-white"
              textClass="text-bbc-neutral-700"
            />
          )}
        </div>
        <div className="px-5 pb-6 pt-7 lg:pb-8">
          <PackageContent
            content={content}
            grid_class={"grid"}
            dataPackage={dataPackage}
            indexEntity={indexEntity}
          />
          {collapse_content && (
            <div className="col-12 mb-2 ">
              <div className={`${styles.collapseContent} `}>
                <div className={""}>
                  {collapse_content.map((item, index) => {
                    const id = item.subTitle.toLowerCase().split(" ").join("-");

                    return (
                      <div
                        key={index}
                        id={id}
                        onClick={(e) => {
                          if (seeMore.includes(id)) {
                            setSeeMore(
                              seeMore.filter((itemId) => itemId !== id)
                            );
                          } else {
                            setSeeMore([...seeMore, id]);
                            const elBoundingRect = document.getElementById(id);

                            scrollToBottomHeader(elBoundingRect);
                          }
                        }}
                        className="cursor-pointer"
                      >
                        <div className="mb-2 flex justify-between">
                          <div className="flex">
                            <span
                              className="mr-2 mt-2 h-2 w-2 rounded-full bg-bbc-brand-500"
                              style={{ minHeight: "8px", minWidth: "8px" }}
                            />
                            <div
                              className="font-semibold leading-bbc-26"
                              dangerouslySetInnerHTML={{
                                __html: item.subTitle,
                              }}
                            />
                          </div>
                          <FiChevronsDown
                            className={`inline-block ${
                              seeMore.includes(id) ? "rotate-180" : ""
                            } transition-transform duration-300 ease-in-out`}
                            size={16}
                            color="#007eff"
                          />
                        </div>
                        <div
                          className={` max-h-0 overflow-hidden ${
                            seeMore.includes(id) && "  max-h-[900px]"
                          } transition-all duration-300 ease-in-out`}
                        >
                          <ContentList
                            content={item}
                            grid_class={"grid-flow-col"}
                          />
                          <div className="pb-2" />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          )}
          {notes?.length > 0 &&
            notes.map((item, index) => (
              <em
                className="mt-2 block text-sm leading-6"
                key={index}
                dangerouslySetInnerHTML={{ __html: item }}
              ></em>
            ))}
          {banner &&
            (bannerLink && bannerLink.length > 0 ? (
              <>
                {dataForm ? (
                  <div
                    id="shortcode_download_form"
                    className="mt-10 rounded-xl p-4"
                    style={{
                      background:
                        "linear-gradient(165.49deg, rgba(117, 121, 231, 0.7) -116.25%, rgba(185, 255, 252, 0.7) 98.96%)",
                    }}
                  >
                    <p className="font-semibold">
                      Stay on top of your business finances with our banking
                      guideline
                    </p>
                    <button onClick={() => showEbookBookModal()}>
                      <Img
                        className="mx-auto mt-6 h-auto w-fit cursor-pointer"
                        src={banner}
                        alt="package banner"
                        width={300}
                        height={192}
                        wrapper={{ className: "w-full " }}
                      />
                    </button>
                    {dataForm && (
                      <FormDownloadModal
                        show={showFormDownload}
                        onHide={() => setShowFormDownload(false)}
                        typeFormDownload="banking_guide"
                      />
                    )}
                  </div>
                ) : (
                  <a href={bannerLink} rel="nofollow">
                    <Img
                      className="mx-auto mt-6 h-auto w-fit cursor-pointer"
                      src={banner}
                      alt="package banner"
                      width={300}
                      height={192}
                      wrapper={{ className: "w-full " }}
                    />
                  </a>
                )}
              </>
            ) : (
              <Img
                className="mx-auto mt-6 h-auto w-fit"
                src={banner}
                alt="package banner"
                width={300}
                height={192}
                wrapper={{ className: "w-full " }}
              />
            ))}
        </div>
      </div>
      <div
        style={{ borderTopWidth: "1.5px" }}
        className=" border-t-bbc-neutral-500 px-5 pt-8 pb-6 text-center"
      >
        {renewal_fee && (
          <RenewalItem
            {...{ price_unit, renewal_fee, renewal_sub }}
            className="mb-3 text-lg font-medium italic text-bbc-brand-700"
          />
        )}
        <a
          href={linkRegister}
          className="inline-block w-full cursor-pointer  rounded-full border border-bbc-brand-500 py-2 px-6 font-normal text-bbc-brand-500 transition-all duration-150 hover:bg-bbc-brand-500 hover:!font-medium hover:text-white"
        >
          Get Started
        </a>
      </div>
    </div>
  );
};

export default CardMobile;

CardMobile.propTypes = {
  notes: PropTypes.array,
  content: PropTypes.array,
  index: PropTypes.number,
};

CardMobile.defaultProps = {
  notes: [],
  content: [],
  index: 0,
};

/** ========== */
